// The frame code is written into the .sh/.bat sorter script the studio runs locally, so the
// backend only accepts letters, digits, spaces and . _ + - ( ). Mirror that while typing.
export const FRAME_CODE_MAX = 40;

export const safeFrameCode = (value) =>
  (value || "").replace(/[^A-Za-z0-9 ._+()-]/g, "").slice(0, FRAME_CODE_MAX);
